<template>
  <div :dir="isHebrew ? 'rtl' : 'ltr'">
    <div class="whatsapp-icon-container-with map-container fix_iteam_right_doun_for_mobile">
      <a @click="retutnToSingleRideWithMap()" class="map-link" :dir="isHebrew ? 'rtl' : 'ltr'">
        <img 
          class="map-icon"
          :src="require('@/assets/images/icons/arrow-left-circle-fill.svg')"
          alt="Close Map"
          >
        <span>{{ t('back') }}</span>
      </a>
    </div>
    <div class="full_size_map">
      <SingleRideMap />
    </div>
  </div>
</template>

<script>
import SingleRideMap from "@/components/SingleRideMap";
import { mapActions, mapGetters } from "vuex";
import { translationMixin } from '@/mixins/translationMixin';

export default {
  name: "FullScreenSingleRideMap",
  mixins: [translationMixin],
  components: {
    SingleRideMap,
  },

  computed: mapGetters([  'allRide' ]),
  
  methods:{
    ...mapActions([ 'rideUpdateMarkerByDayIndex' ]),
    retutnToSingleRideWithMap() {
      const rideId = this.$route.params.id;
      this.$router.push('/single_ride_with_map/' + rideId )
    },
  },
  created() {
    const rideIdFromUrl = this.$route.params.id;
    if (rideIdFromUrl) {
      this.$store.commit("setLowedRideId", rideIdFromUrl);
    }
    const dayId = this.$route.params.dayId;
    this.rideUpdateMarkerByDayIndex( dayId );
  },
};

</script>

<style scoped>
.map-link {
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  text-align: center !important;
  position: relative !important;
}

/* Fixed position for the arrow icon - always on the right side */
.map-link .map-icon {
  position: absolute !important;
  right: 10px !important;
  top: 50% !important;
  transform: translateY(-50%) !important;
  width: 30px !important;
  height: 30px !important;
}

.map-link span {
  text-align: center !important;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding-right: 40px; /* Make space for the fixed icon on the right */
}

/* Language-specific text alignment - keep text centered */
[dir="rtl"] .map-link span {
  text-align: center !important;
  padding-right: 40px;
  padding-left: 0;
}

[dir="ltr"] .map-link span {
  text-align: center !important;
  padding-right: 40px;
  padding-left: 0;
}

/* Keep arrow on the right side for both languages */
[dir="rtl"] .map-link .map-icon,
[dir="ltr"] .map-link .map-icon {
  right: 10px !important;
  left: auto !important;
}
</style>
